import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import useMarkListingAsSold from "@/modules/property-tracks/hooks/listings/mark-as-sold.hook";

export default function MarkAsSoldModal({
  open,
  setOpen,
  listingUid,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  listingUid: string;
}) {
  const mutation = useMarkListingAsSold();

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    mutation.mutate(listingUid, {
      onSuccess: () => {
        handleModalClose();
        showToast({
          type: ToastType.SUCCESS,
          message: "Listing marked as sold successfully",
          toastId: TOAST_IDS.MARK_LISTING_AS_SOLD_SUCCESS,
        });
      },
      onError: (error) => {
        showToast({
          type: ToastType.ERROR,
          message:
            error?.response?.data?.message ||
            "Unexpected error occurred. Please try again.",
          toastId: TOAST_IDS.MARK_LISTING_AS_SOLD_ERROR,
        });
      },
    });
  };
  return (
    <ConfirmationModal
      open={open}
      setOpen={setOpen}
      title="Mark listing as sold"
      body="Are you sure you want to mark this listing a sold?"
      onConfirmHandler={handleConfirm}
      disableConfirmButton={mutation.isPending}
    />
  );
}
